import { useMemo, useContext } from 'react';
import { useDataSelectors } from '../reducers';
import { useGetInfringements } from './useGetInfringements';
import { InfringementSummary } from 'src/app/gql/__generated__/hooks';
import { InfringementDispatchContext } from 'src/@infringements/providers/InfringementsStateProvider';

export const useGetSelectedInfringements = () => {
  const dispatcher = useContext<any>(InfringementDispatchContext);
  const dataSelectors = useDataSelectors();
  const { selectedData } = dataSelectors.getDataInformation();
  const selectedIndexes = selectedData as number[];
  const { data } = useGetInfringements(dispatcher);

  const selectedInfringements = useMemo(() => {
    if (!data?.items) {
      return [];
    }

    return data.items.filter((_, index) =>
      selectedIndexes.includes(index)
    ) as InfringementSummary[];
  }, [data?.items, selectedIndexes]);

  const selectedIds = useMemo((): number[] => {
    if (!data?.items) {
      return [];
    }

    return selectedIndexes
      .map(index => {
        const item = data.items[index];
        return 'id' in item ? item.id : null;
      })
      .filter((id): id is number => id !== null);
  }, [data?.items, selectedIndexes]);

  return {
    selectedIndexes,
    selectedInfringements,
    selectedIds,
  };
};
